<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo v-if="false" />
        <h2 class="brand-text text-primary ml-1">
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Bienvenido! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Inicie sesión en su cuenta y comience la aventura
          </b-card-text>

          <b-alert
            v-if="alert"
            variant="danger"
            show
          >
            <div class="alert-body font-small-2">
              <p>
                <small class="mr-50"><span class="font-weight-bold">Error:</span> {{ alertErrorMessage }}</small>
              </p>
            </div>
          </b-alert>
          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="submit"
            >
              <!-- email -->
              <b-form-group
                label="Correo"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="form.correo"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="pedro.gomez@ejemplo.cl"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Contraseña</label>
                  <!-- <b-link :to="{name:'auth-forgot-password-v2'}">
                    <small>Forgot Password?</small>
                  </b-link> -->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="form.password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group
                v-if="false"
              >
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Recordarme
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
              >
                <b-spinner
                  v-if="spinner"
                  label="Iniciando Sesión"
                  small
                >
                </b-spinner>
                Iniciar Sesión
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup,
  BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    BAlert,
    BSpinner,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      skin: store.state.appConfig.layout.skin,
      spinner: false,
      form: {
        correo: '',
        password: '',
      },
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      alert: false,
      alertErrorMessage: '',
    }
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      authErrorMessage: 'auth/authErrorMessage',
    }),
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    ...mapActions({
      signIn: 'auth/signIn',
    }),
    ...mapMutations('auth', ['SET_ERROR']),
    submit() {
      this.spinner = true
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          // Envía el form a la action signIn
          this.signIn(this.form).then(response => {
            if (response === undefined && this.authErrorMessage === null) {
              localStorage.setItem('userData', JSON.stringify(this.user))
              this.$ability.update(this.user.ability)

              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Bienvenido ${this.user.nombre}`,
                  icon: 'CoffeeIcon',
                  variant: 'primary',
                  text: `Has iniciado sesión correctamente como ${this.user.tipoUsuario}.
                  Ahora puedes comenzar a explorar! 👋`,
                },
              },
              {
                timeout: 2000,
              })
              this.$router.replace({
                name: 'home',
              })
            } else if (response === 'email&pass') {
              this.alert = true
              this.alertErrorMessage = 'El correo electrónico o la contraseña, son incorrectos!'
            }
            if (this.authErrorMessage === 'Usuario Inactivo') {
              this.alert = true
              this.alertErrorMessage = 'El usuario asociado al correo electrónico ingresado, se encuentra Inactivo!'
              store.commit('auth/SET_ERROR', null)
            }
            this.spinner = false
          }).catch(() => {
            this.alert = false
            this.alertErrorMessage = ''
            store.auth.commit('SET_ERROR', null)
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
